module.exports = __webpack_public_path__ + "img/price-2.a434b689.svg";